<!-- TEMPLATE FOR MODAL DIALOG -->
<div class="modal-header">
  <div class="modal-title">
      <h3><i class="fa-regular fa-at mr-2"></i>Kontakta support</h3>
  </div>
  <button type="button" class="close" (click)="close()" aria-label="Close">
      <i title="Stäng" class="fa-regular fa-xmark mr-2"></i>
  </button>
</div>

<div class="modal-body">
  <div class="container-fluid">
      <div class="row">
          @if(!successMessage) {
              <div class="col-12">
                  <div class="form-group">
                      <label for="txtName">Ditt namn</label>
                      <input id="txtName" class="form-control" type="text" [(ngModel)]="name" (input)="validateInputs()" #txtName/>
                  </div>
              </div>

              <div class="col-12">
                  <div class="form-group">
                      <label for="txtEmail">Din epostadress</label>
                      <input id="txtEmail" class="form-control " type="email" [(ngModel)]="email" (input)="validateInputs()"/>
                  </div>
              </div>

              <div class="col-12">
                  <div class="form-group">
                      <label for="txtSubject">Ärende</label>
                      <input id="txtSubject" class="form-control " type="text" [(ngModel)]="subject" (input)="validateInputs()"/>
                  </div>
              </div>

              <div class="col-12">
                  <div class="form-group">
                      <label for="txtMsg">Meddelande</label>
                      <textarea id="txtMsg" class="form-control " [(ngModel)]="message" placeholder="Skriv ett meddelande.." rows="5" (input)="validateInputs()"></textarea>
                  </div>
              </div>
          } @else {
              <div class="col-12">
                  <div class="alert alert-success m-0" [innerHTML]="successMessage"></div>
              </div>
          }

          @if(errorMessage) {
              <div class="col-12">
                  <div class="alert alert-danger m-0" [innerHTML]="errorMessage"></div>
              </div>
          }
      </div>
  </div>
</div>

<div class="modal-footer p-2">
  @if(successMessage) {
      <button class="btn btn-sm btn-danger" (click)="close()">Stäng</button>
  } @else {
      <button class="btn btn-sm btn-primary" [disabled]="!enableSend" (click)="contactSupport()">Skicka <i class="ml-2 fa-regular fa-paper-plane"></i></button>
  }
</div>

